import React, { Fragment } from "react";
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";
import { Modal, Form, Spinner } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { Row, Col } from "react-bootstrap";
import "../../containers/ControlMeasures/ControlMeasures.css";
import ControlMeasuresAdd from "../../components/ControlMeasures/ControlMeasuresAdd";
import UnosDatumaPravomocnosti from "../../components/ControlMeasures/UnosDatumaPravomocnosti";
import UnosDatumaBrisanja from "../../components/ControlMeasures/UnosDatumaBrisanja";
import UnosDatumaDostave from "../../components/ControlMeasures/UnosDatumaDostave";
import UnosUpravnogSpora from "../../components/ControlMeasures/UnosUpravnogSpora";
import UnosPrekrsajnogPostupka from "../../components/ControlMeasures/UnosPrekrsajnogPostupka";
import {
  FormOutlined,
  EditOutlined,
  PaperClipOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import Napomena from "./Napomena";
import { Tooltip } from "antd";
import { useSelector } from "react-redux";

const ControlMeasuresPregled = (props) => {
  const visionImpaired = useSelector((state) => state.layout.visionImpaired);
  const fontSize = useSelector((state) => state.layout.fontSize);
  const { userRole } = props;
  const checkIfUserIsAdmin =
    userRole === "ROLE_REFERENT" || userRole === "ROLE_SLUZBENIK";

  return (
    <>
      <Modal
        animation={true}
        show={props.modalPregled}
        onHide={props.hideModalPregled}
        dialogClassName="modal-90w"
        centered
        style={{ zIndex: "999999" }}
        className={`${visionImpaired ? " visionImpaired" : ""
          }  font${fontSize}`}
      >
        <Modal.Header closeButton>
          <Modal.Title>Pregled izrečenih nadzornih mjera</Modal.Title>
        </Modal.Header>
        {props.table === true && (
          <Row className="justify-content-center" style={{ margin: "20px" }}>
            <Col lg={12} md={12} className="align-self-center">
              <Table
                bordered
                hover
                responsive
                className="table-responsive izrecene"
                style={{ tableLayout: "fixed", border: "0" }}
              >
                <thead>
                  <tr className="tr_table">
                    <th scope="col">Rješenje</th>
                    {/* <th scope="col">Broj rješenja</th> */}
                    <th scope="col">Broj i datum rješenja</th>
                    <th scope="col">Datum pravomoćnosti</th>
                    <th scope="col">Napomena</th>
                    <th scope="col">Vrsta mjere</th>
                    {checkIfUserIsAdmin ? (
                      <th scope="col">Datum dostave rješenja/izvršnost</th>
                    ) : null}
                    <th scope="col">Upravni spor</th>
                    {/* <th scope="col">Upravni spor-Dokument</th> */}
                    <th scope="col">Upravni spor - napomena</th>
                    <th scope="col">Prekršajni postupak</th>
                    {/* <th scope="col">Prekršajni postupak- Dokument</th>  */}
                    <th scope="col">Prekršajni postupak - napomena</th>
                    {props.measureData && checkIfUserIsAdmin ? (
                      <>
                        <th scope="col">Izmijeni</th>
                        <th scope="col">Obriši</th>
                        <th scope="col">Datum brisanja</th>
                      </>
                    ) : null}
                  </tr>
                </thead>
                <tbody>
                  {props.measureData != "" ? (
                    props.measureData.map((element) => (
                      <>
                        <tr className="row-tr">
                          <td className="ikona_dokument_td ant_batn dokument_broj_i_datum">
                            <ButtonComponent
                              className="ikona_dokument"
                              variant="secondary"
                              onClick={(e) =>
                                props.downloadDocument(
                                  e,
                                  element.idMjereOsobe,
                                  element.idMjereDrustva
                                )
                              }
                            >
                              <PaperClipOutlined />
                            </ButtonComponent>
                          </td>
                          {/* <td>{element.brRjesenja}</td> */}

                          <td className="dokument_broj_i_datum">
                            {/* <p className="ikona_dokument" onClick={e =>props.downloadDocument(e,element.idMjereOsobe,element.idMjereDrustva)}> */}
                            <Col>
                              <b>Broj: </b>
                              {element.brRjesenja}
                            </Col>
                            <Col>
                              <b>Datum: </b> {element.datRjesenja}
                            </Col>
                            {/* </p> */}
                          </td>
                          {element.datPravomocnosti != null ? (
                            <td>{element.datPravomocnosti}</td>
                          ) : (
                            <td className="ant_batn">
                              <ButtonComponent
                                variant="secondary"
                                onClick={(e) => {
                                  props.openModalDatPravomocnosti(
                                    element.idSubjekta,
                                    element.idMjereOsobe,
                                    element.idMjereDrustva,
                                    element.idOsobe,
                                    element.idDrustva,
                                    element.datPravomocnosti
                                  );
                                }}
                                disabled={
                                  props.oznAkt != 1 || !checkIfUserIsAdmin
                                }
                              >
                                <EditOutlined />
                              </ButtonComponent>
                            </td>
                          )}
                          <td>
                            {element.napomena ? (
                              element.napomena
                            ) : (
                              <i>Napomena nije unesena.</i>
                            )}
                          </td>
                          <td>{element.vrstaMjere}</td>
                          {checkIfUserIsAdmin ? (
                            element.datPreuzimanja != null ? (
                              <td>{element.datPreuzimanja}</td>
                            ) : (
                              <td className="ant_batn">
                                <ButtonComponent
                                  variant="secondary"
                                  onClick={(e) => {
                                    props.openModalUnosDatDostave(
                                      element.idSubjekta,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva,
                                      element.idOsobe,
                                      element.idDrustva,
                                      element.datPreuzimanja
                                    );
                                  }}
                                  disabled={
                                    props.oznAkt != 1 || !checkIfUserIsAdmin
                                  }
                                >
                                  <EditOutlined />
                                </ButtonComponent>
                              </td>
                            )
                          ) : null}

                          {/* UPRAVNI SPOR */}
                          {element.nazivDok2 === null &&
                            element.napomena2 === null ? (
                            <td colSpan="2" className="ant_batn">
                              <ButtonComponent
                                variant="secondary"
                                disabled={
                                  props.oznAkt != 1 || !checkIfUserIsAdmin
                                }
                                onClick={(e) => {
                                  props.openModalUpravniSpor(
                                    e,
                                    element.idSubjekta,
                                    element.idOsobe,
                                    element.idDrustva,
                                    element.idMjereOsobe,
                                    element.idMjereDrustva
                                  );
                                }}
                              >
                                <FormOutlined />
                              </ButtonComponent>
                            </td>
                          ) : element.nazivDok2 !== null &&
                            element.napomena2 === null ? (
                            <Fragment>
                              <td className="ikona_dokument_td ant_batn">
                                <ButtonComponent
                                  className="ikona_dokument"
                                  variant="secondary"
                                  onClick={(e) =>
                                    props.downloadDocumentUS(
                                      e,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva
                                    )
                                  }
                                >
                                  <PaperClipOutlined />
                                </ButtonComponent>
                              </td>
                              <td>
                                <a
                                  style={{
                                    textDecoration: "underline",
                                    fontSize: "10px",
                                  }}
                                  variant="secondary"
                                  disabled={
                                    props.oznAkt != 1 || !checkIfUserIsAdmin
                                  }
                                  onClick={(e) => {
                                    if (props.oznAkt != 1 || !checkIfUserIsAdmin) {
                                      return
                                    }

                                    props.openModalNapomena(
                                      e,
                                      element.idSubjekta,
                                      element.idOsobe,
                                      element.idDrustva,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva,
                                      2,
                                      element.napomena2
                                    );
                                  }}
                                >
                                  uredi
                                </a>
                              </td>
                            </Fragment>
                          ) : element.nazivDok2 === null &&
                            element.napomena2 !== null ? (
                            <Fragment>
                              <td className="ant_batn">
                                <ButtonComponent
                                  variant="secondary"
                                  disabled={
                                    props.oznAkt != 1 || !checkIfUserIsAdmin
                                  }
                                  onClick={(e) => {
                                    props.openModalUpravniSpor(
                                      e,
                                      element.idSubjekta,
                                      element.idOsobe,
                                      element.idDrustva,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva
                                    );
                                  }}
                                >
                                  <FormOutlined />
                                </ButtonComponent>
                              </td>
                              <td>
                                {element.napomena2}
                                <br />
                                <a
                                  style={{
                                    textDecoration: "underline",
                                    fontSize: "10px",
                                  }}
                                  variant="secondary"
                                  disabled={
                                    props.oznAkt != 1 || !checkIfUserIsAdmin 
                                  }
                                  onClick={(e) => {
                                    if (props.oznAkt != 1 || !checkIfUserIsAdmin) {
                                      return
                                    }
                                    props.openModalNapomena(
                                      e,
                                      element.idSubjekta,
                                      element.idOsobe,
                                      element.idDrustva,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva,
                                      2,
                                      element.napomena2
                                    );
                                  }}
                                >
                                  uredi
                                </a>
                              </td>
                            </Fragment>
                          ) : (
                            <Fragment>
                              <td className="ikona_dokument_td ant_batn">
                                <ButtonComponent
                                  className="ikona_dokument"
                                  variant="secondary"
                                  onClick={(e) =>
                                    props.downloadDocumentUS(
                                      e,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva
                                    )
                                  }
                                >
                                  <PaperClipOutlined />
                                </ButtonComponent>
                              </td>
                              <td>
                                {element.napomena2}
                                <br />
                                <a
                                  style={{
                                    textDecoration: "underline",
                                    fontSize: "10px",
                                  }}
                                  variant="secondary"
                                  disabled={
                                    props.oznAkt != 1 || !checkIfUserIsAdmin
                                  }
                                  onClick={(e) => {
                                    if (props.oznAkt != 1 || !checkIfUserIsAdmin) {
                                      return
                                    }
                                    props.openModalNapomena(
                                      e,
                                      element.idSubjekta,
                                      element.idOsobe,
                                      element.idDrustva,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva,
                                      2,
                                      element.napomena2
                                    );
                                  }}
                                >
                                  uredi
                                </a>
                              </td>
                            </Fragment>
                          )}

                          {/* PREKRŠAJNI POSTUPAK */}
                          {element.nazivDok3 === null &&
                            element.napomena3 === null ? (
                            <td colSpan="2" className="ant_batn">
                              <ButtonComponent
                                variant="secondary"
                                disabled={
                                  props.oznAkt != 1 || !checkIfUserIsAdmin
                                }
                                onClick={(e) => {
                                  props.openModalPP(
                                    e,
                                    element.idSubjekta,
                                    element.idOsobe,
                                    element.idDrustva,
                                    element.idMjereOsobe,
                                    element.idMjereDrustva
                                  );
                                }}
                              >
                                <FormOutlined />
                              </ButtonComponent>
                            </td>
                          ) : element.nazivDok3 !== null &&
                            element.napomena3 === null ? (
                            <Fragment>
                              <td className="ikona_dokument_td ant_batn">
                                <ButtonComponent
                                  className="ikona_dokument"
                                  variant="secondary"
                                  onClick={(e) =>
                                    props.downloadDocumentPP(
                                      e,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva
                                    )
                                  }
                                >
                                  <PaperClipOutlined />
                                </ButtonComponent>
                              </td>
                              <td>
                                <a
                                  style={{
                                    textDecoration: "underline",
                                    fontSize: "10px",
                                  }}
                                  variant="secondary"
                                  disabled={
                                    props.oznAkt != 1 || !checkIfUserIsAdmin
                                  }
                                  onClick={(e) => {
                                    if (props.oznAkt != 1 || !checkIfUserIsAdmin) {
                                      return
                                    }
                                    props.openModalNapomena(
                                      e,
                                      element.idSubjekta,
                                      element.idOsobe,
                                      element.idDrustva,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva,
                                      3,
                                      element.napomena3
                                    );
                                  }}
                                >
                                  uredi
                                </a>
                              </td>
                            </Fragment>
                          ) : element.nazivDok3 === null &&
                            element.napomena3 !== null ? (
                            <Fragment>
                              <td className="ant_batn">
                                <ButtonComponent
                                  variant="secondary"
                                  disabled={
                                    props.oznAkt != 1 || !checkIfUserIsAdmin
                                  }
                                  onClick={(e) => {
                                    props.openModalPP(
                                      e,
                                      element.idSubjekta,
                                      element.idOsobe,
                                      element.idDrustva,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva
                                    );
                                  }}
                                >
                                  <FormOutlined />
                                </ButtonComponent>
                              </td>
                              <td>
                                {element.napomena3}
                                <br />
                                <a
                                  style={{
                                    textDecoration: "underline",
                                    fontSize: "10px",
                                  }}
                                  variant="secondary"
                                  disabled={
                                    props.oznAkt != 1 || !checkIfUserIsAdmin
                                  }
                                  onClick={(e) => {
                                    if (props.oznAkt != 1 || !checkIfUserIsAdmin) {
                                      return
                                    }
                                    props.openModalNapomena(
                                      e,
                                      element.idSubjekta,
                                      element.idOsobe,
                                      element.idDrustva,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva,
                                      3,
                                      element.napomena3
                                    );
                                  }}
                                >
                                  uredi
                                </a>
                              </td>
                            </Fragment>
                          ) : (
                            <Fragment>
                              <td className="ikona_dokument_td ant_batn">
                                <ButtonComponent
                                  className="ikona_dokument"
                                  variant="secondary"
                                  onClick={(e) =>
                                    props.downloadDocumentPP(
                                      e,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva
                                    )
                                  }
                                >
                                  <PaperClipOutlined />
                                </ButtonComponent>
                              </td>
                              <td>
                                {element.napomena3}
                                <br />
                                <a
                                  style={{
                                    textDecoration: "underline",
                                    fontSize: "10px",
                                  }}
                                  variant="secondary"
                                  disabled={
                                    props.oznAkt != 1 || !checkIfUserIsAdmin
                                  }
                                  onClick={(e) => {
                                    if ( props.oznAkt != 1 || !checkIfUserIsAdmin) {
                                      return
                                    }
                                    props.openModalNapomena(
                                      e,
                                      element.idSubjekta,
                                      element.idOsobe,
                                      element.idDrustva,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva,
                                      3,
                                      element.napomena3
                                    );
                                  }}
                                >
                                  uredi
                                </a>
                              </td>
                            </Fragment>
                          )}
                          {/* {element.nazivDok3 != null ? (
                            <td>{element.napomena3}<br/>
                            <a
                              style={{
                                textDecoration: "underline",
                                fontSize: "10px"
                              }}
                              variant="secondary"
                                disabled={
                                  props.oznAkt != 1 || !checkIfUserIsAdmin
                                }
                                onClick={(e) => {
                                  props.openModalNapomena(
                                    e,
                                    element.idSubjekta,
                                    element.idOsobe,
                                    element.idDrustva,
                                    element.idMjereOsobe,
                                    element.idMjereDrustva,
                                    3,
                                    element.napomena3
                                  );
                                }}
                              >
                                {element.napomena3 != null ? 'uredi' : 'uredi'}
                              </a>
                              </td>
                          ) : null} */}
                          {checkIfUserIsAdmin ? (
                            <>
                              <td className="ant_batn">
                                <ButtonComponent
                                  variant="secondary"
                                  onClick={(e) => {
                                    props.openModal(
                                      e,
                                      props.nadzornaMjera,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva,
                                      element,
                                      true
                                    );
                                  }}
                                  disabled={
                                    props.oznAkt != 1 || !checkIfUserIsAdmin
                                  }
                                >
                                  <FormOutlined />
                                </ButtonComponent>
                              </td>
                              {element.datBrisanja === null ? (
                                <td className="disableButton ant_batn">
                                  <Tooltip title="Unesite datum brisanja">
                                    <ButtonComponent
                                      variant="secondary"
                                      style={{
                                        borderColor: "#fff",
                                        color: "#dc3545",
                                        pointerEvents: "none",
                                      }}
                                      onClick={(e) => {
                                        props.openModalObrisi(
                                          element.idSubjekta,
                                          element.idMjereOsobe,
                                          element.idMjereDrustva,
                                          element.idOsobe,
                                          element.idDrustva
                                        );
                                      }}
                                      disabled
                                    >
                                      <DeleteOutlined />
                                    </ButtonComponent>{" "}
                                  </Tooltip>
                                </td>
                              ) : (
                                <td className="disableButton ant_batn">
                                  <ButtonComponent
                                    variant="secondary"
                                    style={{
                                      borderColor: "#fff",
                                      color: "#dc3545",
                                    }}
                                    onClick={(e) => {
                                      props.openModalObrisi(
                                        element.idSubjekta,
                                        element.idMjereOsobe,
                                        element.idMjereDrustva,
                                        element.idOsobe,
                                        element.idDrustva
                                      );
                                    }}
                                    disabled={
                                      props.oznAkt != 1 ||
                                      !checkIfUserIsAdmin ||
                                      element.datBrisanja === null
                                    }
                                  >
                                    <DeleteOutlined />
                                  </ButtonComponent>{" "}
                                </td>
                              )}
                              {element.datBrisanja != null ? (
                                <td>{element.datBrisanja}</td>
                              ) : (
                                <td className="ant_batn">
                                  <ButtonComponent
                                    variant="secondary"
                                    disabled={
                                      props.oznAkt != 1 || !checkIfUserIsAdmin
                                    }
                                    onClick={(e) => {
                                      props.openModalUnosDatBrisanja(
                                        element.idSubjekta,
                                        element.idMjereOsobe,
                                        element.idMjereDrustva,
                                        element.idOsobe,
                                        element.idDrustva,
                                        element.datBrisanja
                                      );
                                    }}
                                  >
                                    <EditOutlined />
                                  </ButtonComponent>
                                </td>
                              )}
                            </>
                          ) : null}
                        </tr>
                      </>
                    ))
                  ) : (
                    <>
                      <tr>
                        {checkIfUserIsAdmin ? (
                          <td colSpan="13">
                            <i>Nema izrečenih nadzornih mjera.</i>
                          </td>
                        ) : (
                          <td colSpan="9">
                            <i>Nema izrečenih nadzornih mjera.</i>
                          </td>
                        )}
                      </tr>
                    </>
                  )}
                </tbody>
              </Table>
            </Col>

            {checkIfUserIsAdmin && props.oznAkt === 1 ? (
              <ButtonComponent
                onClick={(e) => {
                  props.openModal(e, null, null, null, null, false);
                }}
                style={{ marginTop: "4px" }}
              >
                Unesi nadzornu mjeru
              </ButtonComponent>
            ) : (
              ""
            )}
          </Row>
        )}
        {props.tableDeleted === true && (
          <Row className="justify-content-center" style={{ margin: "20px" }}>
            <Col lg={12} md={12} className="align-self-center">
              <h5>Brisane nadzorne mjere</h5>
              <Table
                bordered
                hover
                responsive
                className="table-responsive brisane"
                style={{ border: "0" }}
              >
                <thead>
                  <tr className="tr_table">
                    <th scope="col">Rješenje</th>
                    {/* <th scope="col">Broj rješenja</th> */}
                    <th scope="col">Broj i datum rješenja</th>
                    <th scope="col">Datum pravomoćnosti</th>
                    <th scope="col">Napomena</th>
                    <th scope="col">Vrsta mjere</th>
                    {checkIfUserIsAdmin ? (
                      <th scope="col">Datum dostave rješenja/izvršnost</th>
                    ) : null}
                    <th scope="col">Upravni spor</th>
                    {/* <th scope="col">Upravni spor-Dokument</th> */}
                    <th scope="col">Upravni spor - napomena</th>
                    <th scope="col">Prekršajni postupak</th>
                    {/* <th scope="col">Prekršajni postupak- Dokument</th>  */}
                    <th scope="col">Prekršajni postupak - napomena</th>
                    {props.measureData && checkIfUserIsAdmin ? (
                      <>
                        <th scope="col">Datum brisanja</th>
                      </>
                    ) : null}
                  </tr>
                </thead>
                <tbody>
                  {props.measureDataDeleted != "" ? (
                    props.measureDataDeleted.map((element) => (
                      <>
                        <tr className="row-tr">
                          <td className="ikona_dokument_td ant_batn dokument_broj_i_datum">
                            <ButtonComponent
                              className="ikona_dokument"
                              variant="secondary"
                              onClick={(e) =>
                                props.downloadDocument(
                                  e,
                                  element.idMjereOsobe,
                                  element.idMjereDrustva
                                )
                              }
                            >
                              <PaperClipOutlined />
                            </ButtonComponent>
                          </td>
                          {/* <td>{element.brRjesenja}</td> */}

                          <td className="dokument_broj_i_datum">
                            {/* <p className="ikona_dokument" onClick={e =>props.downloadDocument(e,element.idMjereOsobe,element.idMjereDrustva)}> */}
                            <Col>
                              <b>Broj: </b>
                              {element.brRjesenja}
                            </Col>
                            <Col>
                              <b>Datum: </b> {element.datRjesenja}
                            </Col>
                            {/* </p> */}
                          </td>
                          {element.datPravomocnosti != null ? (
                            <td>{element.datPravomocnosti}</td>
                          ) : (
                            <td>
                              <i>Datum pravomoćnosti nije unesen.</i>
                            </td>
                          )}
                          <td>
                            {element.napomena ? (
                              element.napomena
                            ) : (
                              <i>Napomena nije unesena.</i>
                            )}
                          </td>
                          <td>{element.vrstaMjere}</td>
                          {checkIfUserIsAdmin ? (
                            element.datPreuzimanja != null ? (
                              <td>{element.datPreuzimanja}</td>
                            ) : (
                              <td>
                                <i>Datum dostave rješenja nije unesen.</i>
                              </td>
                            )
                          ) : null}
                          {element.nazivDok2 === null &&
                            element.napomena2 === null ? (
                            <td className="ant_batn">
                              <ButtonComponent variant="secondary" disabled>
                                <PaperClipOutlined />
                              </ButtonComponent>
                            </td>
                          ) : (
                            <td className="ikona_dokument_td ant_batn">
                              {element.nazivDok2 != null ? (
                                <ButtonComponent
                                  className="ikona_dokument"
                                  variant="secondary"
                                  onClick={(e) =>
                                    props.downloadDocumentUS(
                                      e,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva
                                    )
                                  }
                                >
                                  <PaperClipOutlined />
                                </ButtonComponent>
                              ) : (
                                <i>Dokument nije prenesen.</i>
                              )}
                            </td>
                          )}
                          {element.napomena2 != null ? (
                            <td>{element.napomena2}</td>
                          ) : (
                            <td>
                              <i>Napomena nije unesena.</i>
                            </td>
                          )}
                          {element.nazivDok3 === null &&
                            element.napomena3 === null ? (
                            <td className="ikona_dokument_td ant_batn">
                              <ButtonComponent variant="secondary" disabled>
                                <PaperClipOutlined />
                              </ButtonComponent>
                            </td>
                          ) : (
                            <td className="ikona_dokument_td ant_batn">
                              {element.nazivDok3 != null ? (
                                <ButtonComponent
                                  className="ikona_dokument"
                                  variant="secondary"
                                  onClick={(e) =>
                                    props.downloadDocumentPP(
                                      e,
                                      element.idMjereOsobe,
                                      element.idMjereDrustva
                                    )
                                  }
                                >
                                  <PaperClipOutlined />
                                  {/* {element.prPoslovniBroj3} */}
                                </ButtonComponent>
                              ) : (
                                <i>Dokument nije prenesen.</i>
                              )}
                            </td>
                          )}
                          {element.napomena3 != null ? (
                            <td>{element.napomena3}</td>
                          ) : (
                            <td>
                              <i>Napomena nije unesena.</i>
                            </td>
                          )}
                          {checkIfUserIsAdmin ? (
                            <>
                              {element.datBrisanja != null ? (
                                <td>{element.datBrisanja}</td>
                              ) : (
                                <td>
                                  <i>Datum brisanja nije unesen.</i>
                                </td>
                              )}
                            </>
                          ) : null}
                        </tr>
                      </>
                    ))
                  ) : (
                    <>
                      <tr>
                        {checkIfUserIsAdmin ? (
                          <td colSpan="13">
                            <i>Nema brisanih nadzornih mjera.</i>
                          </td>
                        ) : (
                          <td colSpan="9">
                            <i>Nema brisanih nadzornih mjera.</i>
                          </td>
                        )}
                      </tr>
                    </>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        )}

        <Modal.Footer>
          <ButtonComponent onClick={props.hideModalPregled} variant="danger">
            Odustani
          </ButtonComponent>
        </Modal.Footer>
      </Modal>

      <ControlMeasuresAdd
        {...props}
        hideModal={props.hideModal}
        submitHandler={props.submitHandler}
        submitHandlerDat={props.submitHandlerDat}
        mjereDropDownHandler={props.mjereDropDownHandler}
        uploadHandler={props.uploadHandler}
        userInputFormHandler={props.userInputFormHandler}
        datePickerHandler={props.datePickerHandler}
        userInputFormHandlerUS={props.userInputFormHandlerUS}
        datePickerHandlerUS={props.datePickerHandlerUS}
        uploadHandlerUS={props.uploadHandlerUS}
        userInputFormHandlerPP={props.userInputFormHandlerPP}
        datePickerHandlerPP={props.datePickerHandlerPP}
        uploadHandlerPP={props.uploadHandlerPP}
      />
      <UnosDatumaPravomocnosti
        {...props}
        openModalDatPravomocnosti={props.openModalDatPravomocnosti}
        hideModalDat={props.hideModalDat}
        submitHandlerDat={props.submitHandlerDat}
        datePickerHandler={props.datePickerHandler}
      />

      <UnosUpravnogSpora
        {...props}
        openModalUpravniSpor={props.openModalUpraviSpor}
        hideModalUpravniSpor={props.hideModalUpravniSpor}
        userInputFormHandlerUS={props.userInputFormHandlerUS}
        submitHandlerUS={props.submitHandlerUS}
      />

      <UnosPrekrsajnogPostupka
        {...props}
        openModalPP={props.openModalPP}
        hideModalPP={props.hideModalPP}
        userInputFormHandlerPP={props.userInputFormHandlerPP}
        submitHandlerPP={props.submitHandlerPP}
      />

      <Napomena
        {...props}
        openModalNapomena={props.openModalNapomena}
        hideModalNapomena={props.hideModalNapomena}
        userInputNapomena={props.userInputNapomena}
        submitHandlerNapomena={props.submitHandlerNapomena}
      />

      <UnosDatumaBrisanja
        {...props}
        openModalUnosDatBrisanja={props.openModalUnosDatBrisanja}
        hideModalUnosDatBrisanja={props.hideModalUnosDatBrisanja}
        datePickerHandlerDB={props.datePickerHandlerDB}
        submitHandlerDatBrisanja={props.submitHandlerDatBrisanja}
      />

      <UnosDatumaDostave
        {...props}
        openModalUnosDatDostave={props.openModalUnosDatDostave}
        hideModalUnosDatDostave={props.hideModalUnosDatDostave}
        datePickerHandlerDD={props.datePickerHandlerDD}
        submitHandlerDatDostave={props.submitHandlerDatDostave}
      />

      <Modal
        size="md"
        show={props.modalObrisi}
        onHide={props.hideModalObrisi}
        centered
        style={{ zIndex: "999999" }}
        className={`${props.className} ${visionImpaired ? " visionImpaired" : ""
          }  font${fontSize}`}
      >
        <Modal.Header closeButton />
        <div className="row justify-content-center" key={"form"}>
          <div className="align-self-center">
            <Form onSubmit={props.obrisiMjeru}>
              <p>Jeste li sigurni da želite obrisati nadzornu mjeru?</p>

              <div
                className="row"
                key={"button"}
                style={{ marginBottom: "10px" }}
              >
                <div className="col-md-4">
                  <ButtonComponent
                    type="submit"
                    block={true}
                    variant="primary"
                    //onClick={props.hideModalObrisi}
                    disabled={props.loaderBrisanje}
                  >
                    {props.loaderBrisanje ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Da"
                    )}
                  </ButtonComponent>
                </div>
                <div className="col-md-4">
                  <ButtonComponent
                    onClick={props.hideModalObrisi}
                    block={true}
                    variant="danger"
                    style={{ marginRight: "7px" }}
                    disabled={props.loaderBrisanje}
                  >
                    Ne
                  </ButtonComponent>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ControlMeasuresPregled;
